var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"text-align":"left"},attrs:{"fluid":""}},[_c('b-table',{staticStyle:{"width":"100%"},attrs:{"width":"100%","items":_vm.data,"fields":_vm.field},scopedSlots:_vm._u([{key:"value",fn:function(d){return [_vm._v("\n      "+_vm._s(d.item.option_value
          ? ("" + (typeof d.item.option_value === "object" ||
              typeof d.item.option_value === "array"
                ? d.item.option_value.join(", ")
                : d.item.option_value))
          : d.value)+"\n    ")]}}])}),(_vm.data.length <= 0)?_c('b-row',[_c('b-col',[_c('span',[_vm._v("ไม่มีผลข้อมูล")])])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }